var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGanga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 187,
    viewBox: "0 0 195 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#D9D9D9",
    fillOpacity: 0.19
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.5,
    cy: 138.5,
    r: 48.5,
    fill: "#D9D9D9",
    fillOpacity: 0.19
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 159.5,
    cy: 52.5,
    r: 13.5,
    fill: "#D9D9D9",
    fillOpacity: 0.19
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 158,
    r: 13,
    fill: "#D9D9D9",
    fillOpacity: 0.19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142 109V123C142 129.627 136.627 135 130 135C123.373 135 118 129.627 118 123V109C118 102.373 123.373 97 130 97C136.627 97 142 102.373 142 109Z",
    fill: "white",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130 74L116 74C109.373 74 104 68.6274 104 62C104 55.3726 109.373 50 116 50L130 50C136.627 50 142 55.3726 142 62C142 68.6274 136.627 74 130 74Z",
    fill: "white",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130 62H85.4275C75.0593 62.3178 54.2589 70.2627 54.0023 99.5C53.7458 128.737 74.8456 136.682 85.4275 137H128C129.105 137 130 136.105 130 135V108.398",
    stroke: "white",
    strokeWidth: 25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGanga);
export default __webpack_public_path__ + "static/media/ganga.4f672be6eea421773a11e241eafcd55d.svg";
export { ForwardRef as ReactComponent };